import React from 'react';
import { motion } from 'framer-motion';
import { SHOPIFY_URL } from './ui/CTAButton';
import { Gift, Sparkles } from 'lucide-react';
export function SecretBonuses() {
  return <section className="py-16 px-4 bg-black text-white" data-id="element-222">
      <div className="max-w-5xl mx-auto" data-id="element-223">
        <div className="text-center mb-6" data-id="element-224">
          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="inline-block" data-id="element-225">
            <h2 className="text-3xl md:text-5xl font-black text-yellow-400 mb-4 uppercase tracking-tight text-center" data-id="element-226">
              🔥 DOS REGALOS PREMIUM EXTRA
            </h2>
          </motion.div>
          <p className="text-xl font-bold text-gray-300 mb-2" data-id="element-227">
            (solo para quienes compran HOY)
          </p>
          <p className="text-lg text-gray-400 mb-4" data-id="element-228">
            Además de los{' '}
            <span className="text-yellow-400 font-bold" data-id="element-229">
              5 bonos que ya van de regalo
            </span>
            , sumamos estos{' '}
            <span className="text-yellow-400 font-bold" data-id="element-230">
              2 regalos premium extra
            </span>{' '}
            totalmente gratis
          </p>
        </div>

        {/* Premium highlight banner */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-231">
          <div className="bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-600 p-1 rounded-2xl" data-id="element-232">
            <div className="bg-black rounded-xl px-6 py-5 flex flex-col md:flex-row items-center justify-center gap-3 text-center" data-id="element-233">
              <Sparkles className="w-8 h-8 text-yellow-400 flex-shrink-0" data-id="element-234" />
              <p className="text-xl md:text-2xl font-black text-white" data-id="element-235">
                Si realizás la compra{' '}
                <span className="text-yellow-400 underline underline-offset-4 decoration-2" data-id="element-236">
                  HOY MISMO
                </span>
                , te llevás estos{' '}
                <span className="text-yellow-400" data-id="element-237">2 REGALOS PREMIUM EXTRA</span>{' '}
                totalmente <span className="text-green-400" data-id="element-238">GRATIS</span>
              </p>
              <Gift className="w-8 h-8 text-yellow-400 flex-shrink-0" data-id="element-239" />
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-240">
          {/* Secret 1 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gray-900 rounded-3xl p-8 border border-yellow-500/30 shadow-[0_0_30px_rgba(234,179,8,0.15)]" data-id="element-241">
            <a href={SHOPIFY_URL} className="block mb-6 max-w-xs mx-auto" data-id="element-242">
              <motion.img src="https://cdn.magicpatterns.com/uploads/pDb6QG6kJKgzbPLq8o8bhi/7.png" alt="Pack Premium de 30 Textos Cortos" className="w-full aspect-square object-cover rounded-2xl shadow-lg border-2 border-yellow-500/30 cursor-pointer" whileHover={{
              scale: 1.03
            }} data-id="element-243" />
            </a>
            <h3 className="text-2xl font-black text-white mb-3 text-center" data-id="element-244">
              🎁 Pack Premium de 30 Textos Cortos
            </h3>
            <p className="text-gray-400 text-center font-medium mb-4" data-id="element-245">
              15 min/día
            </p>
            <div className="flex flex-col items-center mt-4 bg-black/50 p-4 rounded-xl" data-id="element-246">
              <span className="text-gray-400 line-through text-lg" data-id="element-247">
                Valor real: $29.990 ARS
              </span>
              <motion.span animate={{
              scale: [1, 1.12, 1],
              textShadow: ['0 0 0px rgba(74, 222, 128, 0)', '0 0 20px rgba(74, 222, 128, 0.8)', '0 0 0px rgba(74, 222, 128, 0)']
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="text-green-400 font-black text-3xl uppercase mt-2" data-id="element-248">
                🎉 HOY: GRATIS
              </motion.span>
            </div>
          </motion.div>

          {/* Secret 2 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gray-900 rounded-3xl p-8 border border-yellow-500/30 shadow-[0_0_30px_rgba(234,179,8,0.15)]" data-id="element-249">
            <a href={SHOPIFY_URL} className="block mb-6 max-w-xs mx-auto" data-id="element-250">
              <motion.img src="https://cdn.magicpatterns.com/uploads/wVkpptj343ZseCtBDk5BND/8.png" alt="Kit de Lecturas Piramidales" className="w-full aspect-square object-cover rounded-2xl shadow-lg border-2 border-yellow-500/30 cursor-pointer" whileHover={{
              scale: 1.03
            }} data-id="element-251" />
            </a>
            <h3 className="text-2xl font-black text-white mb-3 text-center" data-id="element-252">
              🎁 Kit de Lecturas Piramidales
            </h3>
            <p className="text-gray-400 text-center font-medium mb-4" data-id="element-253">
              Por niveles, vocabulario y avance gradual
            </p>
            <div className="flex flex-col items-center mt-4 bg-black/50 p-4 rounded-xl" data-id="element-254">
              <span className="text-gray-400 line-through text-lg" data-id="element-255">
                Valor real: $29.990 ARS
              </span>
              <motion.span animate={{
              scale: [1, 1.12, 1],
              textShadow: ['0 0 0px rgba(74, 222, 128, 0)', '0 0 20px rgba(74, 222, 128, 0.8)', '0 0 0px rgba(74, 222, 128, 0)']
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.3
            }} className="text-green-400 font-black text-3xl uppercase mt-2" data-id="element-256">
                🎉 HOY: GRATIS
              </motion.span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}